import { UntypedFormGroup } from "@angular/forms";
import _ from "lodash";
import { Cellstyle, NumericCellChangeArg } from "~app/common/components/hot-doc/hotdoc/cell";
import { IHotDocSettings } from "~app/common/components/hot-doc/hotdoc/doc";
import { Utils } from "~app/common/services/utils";
import { Produktmatris } from "../Produktmatris";
import { AbstractPrismatrisCell } from "./abstractPrismatrisCell";

export class PrismatrisCell extends AbstractPrismatrisCell {
    value: number;
    prismatris: Produktmatris;

    constructor(
        prismatris: Produktmatris,
        form: UntypedFormGroup,
        value: number,
        flags?: Cellstyle,
        onHandle?: (newValue: NumericCellChangeArg) => void) {

        super(prismatris, form, Math.round(value), flags, (newValue: NumericCellChangeArg) => {
            onHandle(newValue);
        });
        this.prismatris = prismatris;
        this.value = Math.round(value);
    }

    static format(value: number): string {
        if (!_.isNumber(value)) {
            console.error(`Not a number ${value}`);
        }
        const val = _.isNumber(value) ? Math.round(value) : 0;
        return `${val.toLocaleString("en").replace(/,/g, " ")}`;
    }

    validate(value: any): boolean {
        return Utils.isNumberLike(value, true);
    }

    override onDelete(settings: IHotDocSettings): void {
        if (this.isReadonly) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        const changeArg = this.changeArgumentFactory(0, () => { }, settings);
        this.onChange(changeArg);
    }

    setReadOnly(): void {
        /* eslint-disable no-bitwise */
        this.flags |= Cellstyle.Readonly;
    }

    protected genHtml(): string {
        return PrismatrisCell.format(this.value);
    }
}
